import brandmark from "@/assets/brandmark.png";
import MenuIcon from "@mui/icons-material/Menu";
import { AppBar, Box, IconButton, Toolbar, Typography } from "@mui/material";
import { useState } from "react";
import { Link as RouterLink, Outlet } from "react-router-dom";
import { AppDrawer } from "./Drawer";

export function AppShell() {
  const [drawerOpen, setDrawerOpen] = useState(false);

  return (
    <Box sx={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
      <AppBar position="static" sx={{ "@media print": { display: "none" } }}>
        <Toolbar sx={{ px: { xs: 1, sm: 2 }, gap: { xs: 0.5, sm: 1 } }}>
          <IconButton
            color="inherit"
            edge="start"
            onClick={() => setDrawerOpen(true)}
            sx={{ mr: { xs: 0.5, sm: 1 } }}
          >
            <MenuIcon />
          </IconButton>
          {/* The brandmark is the way home; its alt is empty because the button is labelled. */}
          <IconButton
            component={RouterLink}
            to="/"
            aria-label="Go to the home page"
            sx={{ p: 0.5 }}
          >
            <Box
              component="img"
              src={brandmark}
              alt=""
              sx={{ display: "block", width: { xs: 32, sm: 40 }, height: { xs: 32, sm: 40 } }}
            />
          </IconButton>
          <Typography
            variant="h6"
            noWrap
            sx={{ flex: 1, minWidth: 0, fontSize: { xs: "1.05rem", sm: "1.25rem" } }}
          >
            Staging Manager
          </Typography>
        </Toolbar>
      </AppBar>
      <AppDrawer open={drawerOpen} onClose={() => setDrawerOpen(false)} />
      <Box component="main" sx={{ flex: 1, display: "flex", flexDirection: "column" }}>
        <Outlet />
      </Box>
    </Box>
  );
}
